<div class="epds_mat_override case-docket-sheet-container" [hidden]="!docketResponse" appAutoFocus>
<!--  <div class="scrollable-content">-->
  <div fxLayout="row" *ngIf="docketResponse">
    <mat-card appearance="outlined" fxFlex="50">
      <mat-card-content class="mat-elevation-z8 no-bottom-pad no-top-pad" id="caseInfoTable">
        <table aria-label="Table with first half of case information" role="presentation" style="width: 100%;">
          <tbody>
          <tr>
            <td><strong>Case Type</strong></td>

            @if (stateService.userRole === UserRole.GAO_Admin) {
              <td>
                @if (caseTypeCtrl.editMode) {
                  <ng-container *ngTemplateOutlet="caseTypeEdit"></ng-container>
                } @else {
                  <ng-container *ngTemplateOutlet="caseTypeRO"></ng-container>
                }
              </td>
              <td>
                <app-edit-controls #caseTypeCtrl
                                   tooltipName="Case Type"
                                   [originalValue]="docketResponse.protestInfo.case_Type"
                                   [(value)]="selectedCaseType"
                                   (onSave)="onFieldSave(docketResponse.protestInfo.a_No, docketResponse.protestInfo.attorney_Group_Id, docketResponse.protestInfo.case_Type, 'Case Type', selectedCaseType, caseTypeCtrl)">
                </app-edit-controls>
              </td>
            } @else {
              <ng-container *ngTemplateOutlet="caseTypeRO"></ng-container>
            }

          </tr>
          <tr>
            <td><strong>Company Status</strong></td>

            @if (stateService.userRole === UserRole.GAO_Admin) {
              <td>
                @if (companyStatusCtrl.editMode) {
                  <ng-container *ngTemplateOutlet="companyStatusEdit"></ng-container>
                } @else {
                  <ng-container *ngTemplateOutlet="companyStatusRO"></ng-container>
                }
              </td>
              <td>
                <app-edit-controls #companyStatusCtrl
                                   tooltipName="Company Status"
                                   [originalValue]="docketResponse.protestInfo.company_Status"
                                   [(value)]="selectedCompanyStatus"
                                   (valueChange)="onCompanyStatusChange()"
                                   (onSave)="onFieldSave(docketResponse.protestInfo.a_No, docketResponse.protestInfo.attorney_Group_Id, docketResponse.protestInfo.company_Status,'Company Status', selectedCompanyStatus, companyStatusCtrl)">
                </app-edit-controls>
              </td>
            } @else {
              <ng-container *ngTemplateOutlet="companyStatusRO"></ng-container>
            }
          </tr>
          <tr>
            <td>
              <strong>{{ docketResponse.protestInfo.company_Name.toLowerCase() === 'reconsideration' ? 'Requester' : 'Protester'}}</strong>
            </td>

            @if (stateService.userRole === UserRole.GAO_Admin) {
              <td>
                @if (protestorCtrl.editMode) {
                  <ng-container *ngTemplateOutlet="protestorEdit"></ng-container>
                } @else {
                  <ng-container *ngTemplateOutlet="protestorRO"></ng-container>
                }
              </td>
              <td>
                <app-edit-controls #protestorCtrl
                                   tooltipName="Protester"
                                   [originalValue]="docketResponse.protestInfo.company_Name"
                                   [(value)]="selectedProtestor"
                                   [saveDisabled]="!selectedProtestor"
                                   (onSave)="onFieldSave(docketResponse.protestInfo.a_No, docketResponse.protestInfo.attorney_Group_Id, docketResponse.protestInfo.company_Name, 'Protester Company Name', selectedProtestor, protestorCtrl)">
                </app-edit-controls>
              </td>
            } @else {
              <ng-container *ngTemplateOutlet="protestorRO"></ng-container>
            }

          </tr>
          <tr>
            <td><strong>B-Number</strong></td>

            @if (stateService.userRole === UserRole.GAO_Admin) {
              <td>
                @if (bNumberCtrl.editMode) {
                  <ng-container *ngTemplateOutlet="bNumberEdit"></ng-container>
                } @else {
                  <ng-container *ngTemplateOutlet="bNumberRO"></ng-container>
                }
              </td>
              <td>
                <app-edit-controls #bNumberCtrl
                                   tooltipName="B-Number"
                                   [originalValue]="docketResponse.protestInfo.b_No"
                                   [(value)]="selectedBnumber"
                                   [saveDisabled]="!selectedBnumber || $any((bNumber && bNumber.invalid && bNumber.touched) || false)"
                                   (onSave)="onFieldSave(docketResponse.protestInfo.a_No, docketResponse.protestInfo.attorney_Group_Id, docketResponse.protestInfo.b_No, 'B Number', selectedBnumber, bNumberCtrl)">
                </app-edit-controls>
              </td>
            } @else {
              <ng-container *ngTemplateOutlet="bNumberRO"></ng-container>
            }
          </tr>

          <tr>
            <td><strong>Agency</strong></td>

            @if (stateService.userRole === UserRole.GAO_Admin) {
              <td>
                @if (agencyCtrl.editMode) {
                  <ng-container *ngTemplateOutlet="agencyEdit"></ng-container>
                } @else {
                  <ng-container *ngTemplateOutlet="agencyRO"></ng-container>
                }
              </td>
              <td>
                <app-edit-controls #agencyCtrl
                                   tooltipName="Agency"
                                   [originalValue]="docketResponse.protestInfo.agency_Name"
                                   [(value)]="selectedAgencies"
                                   [saveDisabled]="!agencySelection || !agencySelection.form.valid || !selectedAgencies?.tier1Agency?.agency_Id"
                                   (onEdit)="onAgencyEdit()"
                                   (onSave)="onFieldSave(docketResponse.protestInfo.a_No, docketResponse.protestInfo.attorney_Group_Id, docketResponse.protestInfo.agency_Name,'Agency Name', selectedAgencies, agencyCtrl)">
                </app-edit-controls>
              </td>
            } @else {
              <ng-container *ngTemplateOutlet="agencyRO"></ng-container>
            }

          </tr>

          <tr>
            <td><strong>Intervenor(s)&nbsp;</strong></td>
            <td><span
              *ngFor="let intervenorCompanyName of docketResponse.intervenorCompanyNameList; index as i; last as isLast"> <!-- remove null and uniq intervenorCompanyName -->
											<span *ngIf="i == 0 && !!intervenorCompanyName">
													{{intervenorCompanyName | uppercase}}
											</span>
              {{isLast ? '' : '; '}}
              <span *ngIf="i != 0 && !!intervenorCompanyName">
											{{intervenorCompanyName | uppercase}}
											</span>
										</span>
            </td>
          </tr>

          <tr>
            <td><strong>Solicitation Number</strong></td>

            @if (stateService.userRole === UserRole.GAO_Admin) {
              <td>
                @if (solicitationNoCtrl.editMode) {
                  <ng-container *ngTemplateOutlet="solicitationNoEdit"></ng-container>
                } @else {
                  <ng-container *ngTemplateOutlet="solicitationNoRO"></ng-container>
                }
              </td>
              <td>
                <app-edit-controls #solicitationNoCtrl
                                   tooltipName="Solicitation Number"
                                   [originalValue]="docketResponse.protestInfo.solicitation_No"
                                   [(value)]="selectedSolicitationNumber"
                                   [saveDisabled]="!selectedSolicitationNumber"
                                   (onSave)="onFieldSave(docketResponse.protestInfo.a_No, docketResponse.protestInfo.attorney_Group_Id, docketResponse.protestInfo.solicitation_No,'Solicitation Number', selectedSolicitationNumber, solicitationNoCtrl)">
                </app-edit-controls>
              </td>
            } @else {
              <ng-container *ngTemplateOutlet="solicitationNoRO"></ng-container>
            }

          </tr>
          <tr>
            <td style="padding-right: 20px;"><strong>Consolidated Protests</strong></td>
            <td>
              <span *ngFor='let childProtestInfo of docketResponse.protestInfo.listOf_ConsolidatedProtest_Info; index as i'>
                  <a (click)="redirectToConsolidatedCaseDocketSheet(childProtestInfo)"
                     *ngIf="i == 0"
                     href="javascript:void(0)">
                    {{childProtestInfo.company_Name | uppercase }}&nbsp;&nbsp;,&nbsp;&nbsp;{{childProtestInfo.b_No}}
                  </a>

                <a *ngIf="i > 0"
                   (click)="redirectToConsolidatedCaseDocketSheet(childProtestInfo)"
                    href="javascript:void(0)">
                    ;&nbsp;&nbsp;{{childProtestInfo.company_Name | uppercase}}&nbsp;&nbsp;,&nbsp;&nbsp;{{childProtestInfo.b_No}};
                </a>
              </span>
            </td>
          </tr>
          </tbody>
        </table>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined" fxFlex="50">
      <mat-card-content class="mat-elevation-z8 no-bottom-pad no-top-pad t2_height">
        <table aria-label="Table with second half of case information" role="presentation"  style="width: 100%;">
          <tr>
            <td><strong>GAO Attorney Name</strong></td>

            @if (stateService.userRole === UserRole.GAO_Admin) {
              <td>
                @if (attorneyNameCtrl.editMode) {
                  <ng-container *ngTemplateOutlet="attorneyNameEdit"></ng-container>
                } @else {
                  <ng-container *ngTemplateOutlet="attorneyNameRO"></ng-container>
                }
              </td>
              <td>
                <app-edit-controls #attorneyNameCtrl
                                   tooltipName="Attorney Name"
                                   [originalValue]="docketResponse.attorneyInfo?.user_Id"
                                   [(value)]="selectedAttorneyId"
                                   [saveDisabled]="!selectedAttorneyId"
                                   (onEdit)="onAttorneyEdit()"
                                   (onSave)="onFieldSave(docketResponse.protestInfo.a_No, selectedAttorneyGroupId, docketResponse.attorneyInfo?.user_Id,'Attorney Info', selectedAttorneyId, attorneyNameCtrl)">
                </app-edit-controls>
              </td>
            } @else {
              <ng-container *ngTemplateOutlet="attorneyNameRO"></ng-container>
            }

          </tr>
          <tr>
            <td><strong>GAO Attorney Email</strong></td>
            <td>{{ docketResponse.attorneyInfo?.email }}</td>
          </tr>
          <tr>
            <td style="padding-right: 20px;">
              <strong>GAO Attorney Phone Number</strong>
            </td>
            <td>
              {{ docketResponse.attorneyInfo?.phone_No }}
            </td>
          </tr>
          <tr>
            <td><strong>Days Remaining&nbsp;</strong></td>
            <td>{{ docketResponse.daysRemaining }}</td>
          </tr>
          <tr>
            <td><strong>Case Status </strong></td>

            @if (stateService.userRole === UserRole.GAO_Admin) {
              <td>
                @if (caseStatusCtrl.editMode) {
                  <ng-container *ngTemplateOutlet="caseStatusEdit"></ng-container>
                } @else {
                  <ng-container *ngTemplateOutlet="caseStatusRO"></ng-container>
                }
              </td>
              <td>
                <app-edit-controls #caseStatusCtrl
                                   tooltipName="Case Status"
                                   [originalValue]="docketResponse.protestInfo.case_Status"
                                   [(value)]="selectedCaseStatus"
                                   (onSave)="onFieldSave(docketResponse.protestInfo.a_No, docketResponse.protestInfo.attorney_Group_Id, docketResponse.protestInfo.case_Status,'Case Status', selectedCaseStatus, caseStatusCtrl)">
                </app-edit-controls>
              </td>
            } @else {
              <ng-container *ngTemplateOutlet="caseStatusRO"></ng-container>
            }

          </tr>
          <tr>
            <td><strong>Protective Order Issued?</strong></td>

            @if ( (stateService.userRole === UserRole.GAO_Admin || stateService.user.role_id === UserRole.GAO_Attorney ||
              stateService.user.role_id === UserRole.GAO_Supervisor) && !docketResponse.protestInfo.viewOnly) {
              <td>
                @if (poCtrl.editMode) {
                  <ng-container *ngTemplateOutlet="poEdit"></ng-container>
                } @else {
                  <ng-container *ngTemplateOutlet="poRO"></ng-container>
                }
              </td>
              <td>
                <app-edit-controls #poCtrl
                                   tooltipName="Protective Order Issued?"
                                   [originalValue]="docketResponse.protestInfo.po"
                                   [(value)]="selectedPOOption"
                                   (onSave)="onFieldSave(docketResponse.protestInfo.a_No, docketResponse.protestInfo.attorney_Group_Id, docketResponse.protestInfo.po,'Protective Order', selectedPOOption, poCtrl)">
                </app-edit-controls>
              </td>
            } @else {
              <ng-container *ngTemplateOutlet="poRO"></ng-container>
            }

          </tr>

          <tr [hidden]="!(docketResponse.protestInfo.caseCompletionStatus.dmNumber != null
								        && docketResponse.protestInfo.caseCompletionStatus.isDmVerfied !== true
								        &&  (stateService.user.role_id == UserRole.GAO_Admin || stateService.user.role_id == UserRole.GAO_Attorney || stateService.user.role_id == UserRole.GAO_Supervisor))">

            <td><strong>DM#</strong></td>

            <td>
              @if (dmNumberCtrl.editMode) {
                <ng-container *ngTemplateOutlet="dmNumberEdit"></ng-container>
              } @else {
                <ng-container *ngTemplateOutlet="dmNumberRO"></ng-container>
              }
            </td>
            <td>
              <app-edit-controls #dmNumberCtrl
                                 tooltipName="DM Number"
                                 [originalValue]="docketResponse.protestInfo.caseCompletionStatus.dmNumber"
                                 [(value)]="selectedDMNumber"
                                 [saveDisabled]="!selectedDMNumber || $any((dmNumber && dmNumber.invalid && dmNumber.touched) || false)"
                                 (onSave)="onDMNumberSave(docketResponse.protestInfo.a_No, selectedDMNumber, dmNumberCtrl)">
              </app-edit-controls>
            </td>

          </tr>
        </table>
      </mat-card-content>
    </mat-card>
  </div>
  <mat-card appearance="outlined">
    <mat-card-content class="mat-elevation-z8 no-bottom-pad" fxLayout="column">
      <div fxLayout style="position: sticky;top:0">
        <div fxLayoutAlign="start" fxFlex="20">
          <button mat-icon-button color="accent"
                  [disabled]="!dataSource.data.length"
                  matTooltip="Download Offline Case Docket"
                  (click)="onDownload()">
            <mat-icon>save_alt</mat-icon>
          </button>

          <mat-form-field floatLabel="always" appearance="outline">
            <mat-label>Filter</mat-label>
            <input matInput type="text" (keyup)="applyFilter($event)" #filterInput>
            <button mat-icon-button *ngIf="filterInput.value" matSuffix aria-label="Clear"
                    (click)="filterInput.value='';applyFilter($event); $event.stopPropagation()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div fxFlex></div>
        <div fxFlex="60">
          <mat-paginator appPaginationSave [lsKey]="'case_docket_page_size'" [pageSizeOptions]="[5, 10, 25, 50, 100]"
                         showFirstLastButtons aria-label="Select page of dockets" >
          </mat-paginator>
        </div>
        @if ( (stateService.userRole === UserRole.GAO_Admin || stateService.user.role_id === UserRole.GAO_Attorney ||
          stateService.user.role_id === UserRole.GAO_Supervisor) && (docketResponse && !docketResponse.protestInfo.viewOnly) ) {
          <div fxFlex="20" fxLayoutAlign="end">
            <button mat-raised-button color="accent" (click)="onAddMinuteEntry()">Add Minute Entry</button>
          </div>
        }
      </div>
      <div class="scrollable-content">
      <table mat-table matSort [dataSource]="dataSource" (matSortChange)="util.announceSortChange($event)" style="width: 100%">

        <ng-container matColumnDef="indexNum">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Index">
            Index
          </th>
          <td *matCellDef="let fileInfo" mat-cell>{{fileInfo.indexNum}}</td>
        </ng-container>

        <ng-container matColumnDef="fileAlert">
          <th mat-header-cell *matHeaderCellDef>Alerts</th>
          <td *matCellDef="let fileInfo" mat-cell><!-- ngif -->
            <div [hidden]="(fileInfo.doc_Type_Id == 157
													|| fileInfo.doc_Type_Id == 159
													|| fileInfo.doc_Type_Id == 161
													|| fileInfo.doc_Type_Id == 162
                          || [27,38,12,179,53,100,91,82,67,154,234,233,231,232,215,214,213,212,211,210].includes(fileInfo.doc_Type_Id)
													|| docketResponse.protestInfo.caseCompletionStatus.isZipCreated === true)
													&& fileInfo.doc_Type_Id != 158">
              <img [hidden]="!(fileInfo.fileAlert =='Y')" height="22"
                   src="assets/img/notification_warning.png" title="Unread document"
                  >
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="docTypeName">
          <th mat-header-cell *matHeaderCellDef>
            Type of Filing
          </th>
          <td *matCellDef="let fileInfo; let index = index" mat-cell> <!-- backend for loop -->
            <div [hidden]="!(fileInfo.is_Visible == 'N'
																|| fileInfo.doc_Type_Id == 157
																|| fileInfo.doc_Type_Id == 159
																|| fileInfo.doc_Type_Id == 161
																|| fileInfo.doc_Type_Id == 162
                                || [27,38,12,179,53,100,91,82,67,154,234,233,231,232,215,214,213,212,211,210].includes(fileInfo.doc_Type_Id)
																|| docketResponse.protestInfo.caseCompletionStatus.isZipCreated === true)
																&& fileInfo.doc_Type_Id != 158"
                                class="center-content">
              <span>{{ splitString(fileInfo.docTypeName) }}</span>
              <span [hidden]="!(fileInfo.doc_Type_Id != 160 && fileInfo.doc_Type_Id != 161)">
                {{fileInfo.filler}}
              </span>
            </div>

            <div [hidden]="!(fileInfo.is_Visible == 'Y'
													&& fileInfo.doc_Type_Id != 157
													&& fileInfo.doc_Type_Id != 158
													&& fileInfo.doc_Type_Id != 159
													&& fileInfo.doc_Type_Id != 161
                          && ![27,38,12,179,53,100,91,82,67,154,234,233,231,232,215,214,213,212,211,210].includes(fileInfo.doc_Type_Id)
													&& fileInfo.doc_Type_Id != 162
													&& docketResponse.protestInfo.caseCompletionStatus.isZipCreated !== true)">

              @if (typeOfFilingCtrl.editMode) {
                <mat-form-field appearance="outline" floatLabel="always" class="type-of-filing-field" style="padding-top: 20px;">
                  <mat-label>Type of Filing</mat-label>
                  <mat-select panelWidth=""
                              [(value)]="selectedDocType[index]"
                              (selectionChange)="onDocTypeChangeChange($event, index)">
                    <mat-optgroup *ngFor="let group of docTypeGroups" [label]="group">
                      <mat-option *ngFor="let docType of docTypesByGroup.get(group)" [value]="docType">
                        {{ docType.doc_Type_Desc }}
                      </mat-option>
                    </mat-optgroup>
                  </mat-select>
                </mat-form-field>
              } @else {
                <a (click)="redirectToCaseDocketFileInfo(docketResponse.protestInfo.a_No, fileInfo.originalSubmissionDate,
                    fileInfo.doc_Type_Id, fileInfo.fileAlert, fileInfo.indexNum)" href="javascript:void(0)" class="center-content">
                  {{ splitString(fileInfo.docTypeName) }}
                  <span [hidden]="!(fileInfo.doc_Type_Id != 160 && fileInfo.doc_Type_Id != 161)">
                    {{fileInfo.filler}}
                  </span>
                </a>
              }
              <div fxFlex=""></div>
              <app-edit-controls #typeOfFilingCtrl
                                 [hidden]="stateService.user.role_id != UserRole.GAO_Admin"
                                 tooltipName="Type of filing"
                                 [originalValue]="fileInfo.doc_Type_Id"
                                 [(value)]="selectedDocTypeId[index]"
                                 [saveDisabled]="!selectedDocTypeId[index]"
                                 (onEdit)="onDocTypeEdit(fileInfo, index)"
                                 (onSave)="onDocTypeSave(docketResponse.protestInfo.a_No, fileInfo, selectedDocType[index], typeOfFilingCtrl)">
              </app-edit-controls>
            </div>

            <div [hidden]="!(fileInfo.doc_Type_Id == 158 && (stateService.user.role_id == UserRole.GAO_Admin ||
                stateService.user.role_id == UserRole.GAO_Attorney || stateService.user.role_id == UserRole.GAO_Supervisor))">
              <a (click)="redirectToCaseDocketFileInfo(docketResponse.protestInfo.a_No, fileInfo.originalSubmissionDate,
                  fileInfo.doc_Type_Id, fileInfo.fileAlert, fileInfo.indexNum)" href="javascript:void(0)">
                <span>{{ docketResponse.protestInfo.b_No }}</span>
              </a>
            </div>

          </td>
        </ng-container>

        <ng-container matColumnDef="submitter_Role">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Filer">Filer</th>
          <td *matCellDef="let fileInfo" mat-cell>
            <div *ngIf="fileInfo.submitter_Role != 'GAO'">
              <span>{{fileInfo.submitter_Role}}</span>
              <br *ngIf="fileInfo.company_Name">
              <span *ngIf="fileInfo.company_Name">
                ({{fileInfo.company_Name}})
              </span>
            </div>
            <div *ngIf="fileInfo.submitter_Role == 'GAO'">
              <span>GAO</span><br>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="is_Confidential">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Protected">Protected?</th>
          <td *matCellDef="let fileInfo" mat-cell> {{fileInfo.is_Confidential === 'Y' ? "YES" : "NO"}} </td>
        </ng-container>

        <ng-container matColumnDef="transient_Time">
          <th mat-header-cell *matHeaderCellDef  mat-sort-header sortActionDescription="Sort by Date"> Date
          </th>
          <td *matCellDef="let fileInfo" mat-cell>
            <div>
              <span>
                {{fileInfo.transient_Date | date:'MMM dd yyyy'}}
                <br>
                {{fileInfo.transient_Time}}
              </span>
              <div fxFlex=""></div>
              <button mat-icon-button color="primary"
                      (click)="onUpdateSubmissionDate(fileInfo)"
                      [hidden]="!(stateService.user.role_id == UserRole.GAO_Admin && !docketResponse.protestInfo.viewOnly)"
                      matTooltip="Edit date">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </td>

        </ng-container>

        <ng-container matColumnDef="transient_Note">
          <th mat-header-cell *matHeaderCellDef>Comments</th>
          <td *matCellDef="let fileInfo" mat-cell>

            <div [hidden]="fileInfo.transient_Comments">
              <div>
                <button mat-icon-button color="primary"
                        (click)="addComments(fileInfo, fileInfo.file_Id, fileInfo.transient_Comments)"
                        [hidden]="!(stateService.user.role_id == UserRole.GAO_Admin && !docketResponse.protestInfo.viewOnly)"
                        matTooltip="Add comments">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>

            <div [hidden]="!fileInfo.transient_Comments">
              <div>
                <span class="center-content"> {{fileInfo.transient_Comments}} </span>
                <div fxFlex=""></div>
                <button mat-icon-button color="primary"
                        (click)="addComments(fileInfo, fileInfo.file_Id, fileInfo.transient_Comments)"
                        [hidden]="!((stateService.user.role_id == UserRole.GAO_Admin || stateService.user.role_id == UserRole.GAO_Attorney || stateService.user.role_id == UserRole.GAO_Supervisor) && !docketResponse.protestInfo.viewOnly)"
                        matTooltip="Edit comments">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>

              <div *ngIf="fileInfo.isCommentEdited  && fileInfo.isCommentEdited.trim() == 'Y'">
                <strong>
                  <em>
                  <span>Edited:</span>
                    {{fileInfo.transient_Comments_Date}}
                  </em>
                </strong>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="attorney_Note">
          <th mat-header-cell *matHeaderCellDef>GAO Notes</th>
          <td *matCellDef="let fileInfo" mat-cell>

            <div [hidden]="!(fileInfo.attorney_Note == null)">
              <div>
                <button mat-icon-button color="primary"
                        (click)="addAttorneyNotes(fileInfo, fileInfo.file_Id, fileInfo.transient_Note)"
                        [hidden]="!((stateService.user.role_id == UserRole.GAO_Admin || stateService.user.role_id == UserRole.GAO_Attorney || stateService.user.role_id == UserRole.GAO_Supervisor) && !docketResponse.protestInfo.viewOnly)"
                        matTooltip="Add attorney notes">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>

            <div [hidden]="!(fileInfo.attorney_Note != null)">
              <div>
                <span class="center-content">{{ fileInfo.transient_Note }}</span>
                <div fxFlex=""></div>
                <button mat-icon-button color="primary"
                        (click)="addAttorneyNotes(fileInfo, fileInfo.file_Id, fileInfo.transient_Note)"
                        [hidden]="!((stateService.user.role_id == UserRole.GAO_Admin || stateService.user.role_id == UserRole.GAO_Attorney || stateService.user.role_id == UserRole.GAO_Supervisor) && !docketResponse.protestInfo.viewOnly)"
                        matTooltip="Edit attorney notes">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>

              <div *ngIf="fileInfo.isAttorneyNoteEdited  && fileInfo.isAttorneyNoteEdited.trim() == 'Y'">
                <strong>
                  <em>
                    <span>Edited:</span>
                    {{fileInfo.transient_Attorney_Note_Date}}
                  </em>
                </strong>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="5">No data or nothing that matches the filter "{{filterInput.value}}"</td>
        </tr>
      </table>
      </div>
    </mat-card-content>
  </mat-card>
<!--  </div>-->

<!--  <mat-card>-->
<!--    <mat-card-content class="no-bottom-pad half-top-pad">-->
<!--      <div fxLayout>-->
<!--        <div fxLayoutAlign="start" fxFlex="20">-->
<!--          <button mat-icon-button color="accent"-->
<!--                  [disabled]="!dataSource.data.length"-->
<!--                  matTooltip="Download Offline Case Docket"-->
<!--                  (click)="onDownload()">-->
<!--            <mat-icon>save_alt</mat-icon>-->
<!--          </button>-->

<!--          <mat-form-field floatLabel="always" appearance="outline">-->
<!--            <mat-label>Filter</mat-label>-->
<!--            <input matInput type="text" (keyup)="applyFilter($event)" #filterInput>-->
<!--            <button mat-icon-button *ngIf="filterInput.value" matSuffix aria-label="Clear"-->
<!--                    (click)="filterInput.value='';applyFilter($event); $event.stopPropagation()">-->
<!--              <mat-icon>close</mat-icon>-->
<!--            </button>-->
<!--          </mat-form-field>-->
<!--        </div>-->
<!--        <div fxFlex></div>-->
<!--        <div fxFlex="60">-->
<!--          <mat-paginator appPaginationSave [lsKey]="'case_docket_page_size'" [pageSizeOptions]="[5, 10, 25, 50, 100]"-->
<!--                         showFirstLastButtons aria-label="Select page of dockets" >-->
<!--          </mat-paginator>-->
<!--        </div>-->
<!--        @if ( (stateService.userRole === UserRole.GAO_Admin || stateService.user.role_id === UserRole.GAO_Attorney ||-->
<!--          stateService.user.role_id === UserRole.GAO_Supervisor) && (docketResponse && !docketResponse.protestInfo.viewOnly) ) {-->
<!--          <div fxFlex="20" fxLayoutAlign="end">-->
<!--            <button mat-raised-button color="accent" (click)="onAddMinuteEntry()">Add Minute Entry</button>-->
<!--          </div>-->
<!--        }-->
<!--      </div>-->
<!--    </mat-card-content>-->
<!--  </mat-card>-->
</div>


<ng-template #caseTypeRO>
  <span>{{ docketResponse.protestInfo.case_Type | uppercase }}</span>
</ng-template>
<ng-template #caseTypeEdit>
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Case Type</mat-label>
    <mat-select [(value)]="selectedCaseType">
      <mat-option *ngFor="let caseType of caseTypes" [value]="caseType.value">
        {{ caseType.text }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-template>

<ng-template #companyStatusRO>
  <span>{{ docketResponse.protestInfo.company_Status | uppercase }}</span>
</ng-template>
<ng-template #companyStatusEdit>
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Company Status</mat-label>
    <mat-select [(value)]="selectedCompanyStatus">
      <mat-option *ngFor="let companyStatus of companyStatuses" [value]="companyStatus.value">
        {{ companyStatus.text }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-template>

<ng-template #protestorRO>
  <span>{{ docketResponse.protestInfo.company_Name | uppercase }}</span>
</ng-template>
<ng-template #protestorEdit>
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>{{ docketResponse.protestInfo.company_Name.toLowerCase() === 'reconsideration' ? 'Requester' : 'Protester'}}</mat-label>
    <input matInput [(ngModel)]="selectedProtestor">
  </mat-form-field>
</ng-template>

<ng-template #bNumberRO>
  @if (stateService.userRole === UserRole.GAO_Admin) {
    <span [ngClass]="{ 'pending-entry color_warn': !docketResponse.protestInfo.b_No }" [matTooltip]="docketResponse.protestInfo.a_No">
      {{docketResponse.protestInfo.b_No || "pending"}}
    </span>
    @if (docketResponse.protestInfo.supplemental_B_Nos) {
      <span [matTooltip]="docketResponse.protestInfo.supplemental_A_Nos">
        {{docketResponse.protestInfo.supplemental_B_Nos}}
      </span>
    }
  } @else {
    <span [ngClass]="{ 'pending-entry color_warn': !docketResponse.protestInfo.b_No }">
      {{docketResponse.protestInfo.b_No || "pending"}}
    </span>
    @if (docketResponse.protestInfo.supplemental_B_Nos) {
      <span>
        {{docketResponse.protestInfo.supplemental_B_Nos}}
      </span>
    }
  }
</ng-template>

<ng-template #bNumberEdit>
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>B-Number</mat-label>
    <input matInput id="bNumber" name="bNumber" #bNumber="ngModel" [(ngModel)]="selectedBnumber" (input)="checkBNumber(bNumber)">
    <mat-error *ngIf="bNumber.invalid && bNumber.touched">{{bNumber.errors?.['error'] ? bNumber.errors?.['error'] : 'B-Number invalid.'}}</mat-error>
  </mat-form-field>
</ng-template>

<ng-template #agencyRO>
  <span>{{ docketResponse.protestInfo.agency_Name }}</span>
</ng-template>
<ng-template #agencyEdit>
  <mat-form-field appearance="outline" floatLabel="always" class="agency-field">
    <mat-label>Agency</mat-label>
    <input matInput style="display:none">
    <app-agency #agencies (agencies)="onSelectedAgencies($event)" [tier2Required]="true" layout="column"></app-agency>
  </mat-form-field>
</ng-template>

<ng-template #solicitationNoRO>
  <span>{{ docketResponse.protestInfo.solicitation_No }}</span>
</ng-template>
<ng-template #solicitationNoEdit>
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Solicitation Number</mat-label>
    <input matInput [(ngModel)]="selectedSolicitationNumber">
  </mat-form-field>
</ng-template>

<ng-template #attorneyNameRO>
  <span [ngClass]="{ 'pending-entry color_warn': !docketResponse.protestInfo.attorney_Name }">
    {{ docketResponse.protestInfo.attorney_Name || "pending" }}
  </span>
</ng-template>
<ng-template #attorneyNameEdit>
  <mat-form-field appearance="outline" floatLabel="always" class="attorney-field">
    <mat-label>GAO Attorney Name</mat-label>
    <mat-select panelClass="epds-select-override" panelWidth=""
                [(value)]="selectedAttorney"
                (selectionChange)="onAttorneyChange($event)">
      <mat-optgroup *ngFor="let group of attorneyGroups" [label]="'Group ' + group">
        <mat-option *ngFor="let attorney of attorneysByGroup.get(group)" [value]="attorney">
          {{ attorney.last_Name + ', ' + attorney.first_Name }}
        </mat-option>
      </mat-optgroup>
    </mat-select>
  </mat-form-field>
</ng-template>

<ng-template #caseStatusRO>
  <span>{{ docketResponse.protestInfo.case_Status | uppercase }}</span>
</ng-template>
<ng-template #caseStatusEdit>
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Case Status</mat-label>
    <mat-select [(value)]="selectedCaseStatus">
      <mat-option *ngFor="let caseStatus of caseStatuses" [value]="caseStatus.value">
        {{ caseStatus.text }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-template>

<ng-template #poRO>
  <span>{{ docketResponse.protestInfo.po}}</span>
</ng-template>
<ng-template #poEdit>
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>Protective Order Issued</mat-label>
    <input matInput style="display:none">
    <mat-radio-group [(ngModel)]="selectedPOOption">
      <mat-radio-button *ngFor="let protectiveOrderOption of protectiveOrderOptions" [value]="protectiveOrderOption.value">
        {{ protectiveOrderOption.text }}
      </mat-radio-button>
    </mat-radio-group>
  </mat-form-field>
</ng-template>

<ng-template #dmNumberRO>
  <span>{{ docketResponse.protestInfo.caseCompletionStatus.dmNumber }}</span>
</ng-template>
<ng-template #dmNumberEdit>
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>DM #</mat-label>
    <input matInput id="dmNumber" name="dmNumber" #dmNumber="ngModel" [(ngModel)]="selectedDMNumber" (input)="checkDMNumber(dmNumber)">
    <mat-error *ngIf="dmNumber.invalid && dmNumber.touched">{{dmNumber.errors?.['error'] ? dmNumber.errors?.['error'] : 'DM # invalid.'}}</mat-error>
  </mat-form-field>
</ng-template>
